import {
  FETCH_CHALLENGES,
  FETCH_LEADERBOARD,
  SHOWPOPUP_MODAL,
  CERTIFICATE_MODAL
} from '../actions';

export function gamificationChallenges(state = [], action) {
  switch (action.type) {
    case FETCH_CHALLENGES:
      return action.payload;
    default:
      return state;
  }
}

export function gamificationLeaderboard(state = [], action) {
  switch (action.type) {
    case FETCH_LEADERBOARD:
      return action.payload;
    default:
      return state;
  }
}

export function gamificationShowpopup(state = [], action) {
  switch (action.type) {
    case SHOWPOPUP_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function showAward(state = [], action) {
  switch (action.type) {
    case CERTIFICATE_MODAL:
      return action.payload;
    default:
      return state;
  }
}
